import { API, axiosInstance } from "lib";

export const getBroadcastingHistoryList = (data = {}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("page", data?.page);
  queryParams.append("limit", data?.limit || null);
  queryParams.append("startDate", data?.startDate);
  queryParams.append("endDate", data?.endDate);
  queryParams.append("keyword", data?.keyword);
  queryParams.append("sourceType", data?.sourceType);

  return axiosInstance
    .get(`${API.BROADCAST_HISTORY_LIST}?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

export const uploadBroadCasting = (data = {}) => {
  return axiosInstance
    .post(API.UPDATE_BROADCAST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
      }
      throw err;
    });
};

export const sendBroadcastEmail = (data = {}) => {
  return axiosInstance
    .post(API.SEND_BROADCAST_EMAIL, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
      }
      throw err;
    });
};

